export default __webpack_public_path__ + "static/media/Fernando Arnal.b8236c61.jpg";